<template>
  <div class="setting-container">
    <el-form ref="form" :model="postForm" label-width="100px">
      <el-form-item label="当前会员年度">
        <el-input v-model="currentYearDuration" disabled />
      </el-form-item>
      <el-form-item label="会费重置时间">
        <el-input v-model="duesResetDate" disabled />
      </el-form-item>
      <el-form-item label="开放注册类型">
        <el-checkbox-group v-model="currentRoleStatus">
          <div class="item">
            <el-checkbox class="item-checkbox" :label="1">会员单位</el-checkbox>
            <el-date-picker
              v-model="currentOrgRange"
              :default-time="['00:00:00', '23:59:59']"
              class="date-picker"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"/>
          </div>
          <div class="item">
            <el-checkbox class="item-checkbox" :label="2">运动员</el-checkbox>
            <el-date-picker
              v-model="currentPlayerRange"
              :default-time="['00:00:00', '23:59:59']"
              class="date-picker"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"/>
          </div>
          <div class="item">
            <el-checkbox class="item-checkbox" :label="3">教练员</el-checkbox>
          </div>
          <div class="item">
            <el-checkbox class="item-checkbox" :label="4">场内裁判员</el-checkbox>
          </div>
          <div class="item">
            <el-checkbox class="item-checkbox" :label="5">场外裁判员</el-checkbox>
          </div>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="补录数据模式">
        <el-radio-group v-model="oldDataMode" @change="handleModeChanged">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="下一年度信息">
      </el-form-item>
    </el-form>

    <el-form :model="nextYear" class="modal" label-width="100px">
      <el-form-item label="会员年度名称">
        <el-input v-model="nextYear.year" disabled/>
      </el-form-item>
      <el-form-item label="会员开始时间">
        <el-date-picker
          v-model="nextYear.membershipBeginDate"
          type="date"
          placeholder="选择日期" />
      </el-form-item>
      <el-form-item label="会员结束时间">
        <el-date-picker
          v-model="nextYear.membershipEndDate"
          type="date"
          placeholder="选择日期" />
      </el-form-item>
      <el-form-item label="费用重置时间">
        <el-date-picker
          v-model="nextYear.overallRegisterBeginDate"
          type="date"
          placeholder="选择日期" />
      </el-form-item>

      <el-form-item label="开放注册角色">
        <el-checkbox-group v-model="nextRoleStatus">
          <div class="item">
            <el-checkbox class="item-checkbox block" :label="1">会员单位</el-checkbox>
            <el-date-picker
              v-model="nextOrgRange"
              :default-time="['00:00:00', '23:59:59']"
              class="date-picker"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"/>
          </div>
          <div class="item">
            <el-checkbox class="item-checkbox block" :label="2">运动员</el-checkbox>
            <el-date-picker
              v-model="nextPlayerRange"
              :default-time="['00:00:00', '23:59:59']"
              class="date-picker"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"/>
          </div>
          <div class="item">
            <el-checkbox class="item-checkbox" :label="3">教练员</el-checkbox>
          </div>
          <div class="item">
            <el-checkbox class="item-checkbox" :label="4">场内裁判员</el-checkbox>
          </div>
          <div class="item">
            <el-checkbox class="item-checkbox" :label="5">场外裁判员</el-checkbox>
          </div>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
      </el-form-item>

    </el-form>

    <!-- next year modal start -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="下一年度信息设置" center>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onDialogSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- next year modal start -->
  </div>
</template>

<script>
  import * as moment from 'moment'
  import find from 'lodash/find'
  import includes from 'lodash/includes'
  import {getDateObjectByString} from '@/utils'
  import {getMemberShipTypeList, getMemberShipYearList, updateMemberShipYear, updateOldDataMode} from '@/api/site'

  const defaultForm = {}
let filters = {};
// 开始时间与结束时间比较
filters.CompareDate=function(start,end)
{
  return ((new Date(start.replace(/-/g,"\/"))) < (new Date(end.replace(/-/g,"\/"))));
}

export default {
  name: 'Setting',
  data() {
    return {
      postForm: Object.assign({}, defaultForm),
      loading: false,
      currentYear: {},
      currentYearDuration: '',
      currentOrgRange: [],
      currentPlayerRange: [],
      currentRoleStatus: [],
      duesResetDate: '',
      nextYear: {},
      nextYearDuration: '',
      nextOrgRange: [],
      nextPlayerRange: [],
      nextRoleStatus: [],
      memberList: [],
      oldDataMode: 0,
      dialogVisible: false,
      formLabelWidth: '120px'
    }
  },
  computed: {
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleModeChanged() {
      updateOldDataMode(this.oldDataMode).then(response =>{
        //idle
      })
    },
    removeDomain(d) {

    },
    fetchData(query) {
      getMemberShipYearList().then(response => {
        const data = response.data
        if (!data.list) return
        const currentYear = this.currentYear = find(data.list, function (item) { // TODO
          return item.current == 1
        })
        debugger
        const currentOrgRegisterBeginDate = getDateObjectByString(currentYear.orgRegisterBeginDate);
        const currentOrgRegisterEndDate = getDateObjectByString(currentYear.orgRegisterEndDate);
        const currentPlayerRegisterBeginDate = getDateObjectByString(currentYear.playerRegisterBeginDate);
        const currentPlayerRegisterEndDate = getDateObjectByString(currentYear.playerRegisterEndDate);
        this.currentOrgRange = [currentOrgRegisterBeginDate, currentOrgRegisterEndDate]
        this.currentPlayerRange = [currentPlayerRegisterBeginDate, currentPlayerRegisterEndDate]
        this.mapMemberType(this.currentRoleStatus, currentYear)

        this.currentYearDuration = currentYear.year + '年度，' + moment(currentYear.membershipBeginDate).format('YYYY-MM-DD') + ' ~ ' + moment(currentYear.membershipEndDate).format('YYYY-MM-DD')
        this.duesResetDate = moment(currentYear.overallRegisterBeginDate).format('YYYY-MM-DD')

        const nextYear= find(data.list, function (item) { // TODO
          return item.year == currentYear.year + 1
        })
        if (nextYear) {
          this.nextYear = nextYear
          this.nextYearDuration = nextYear.year + '年度，' + moment(nextYear.membershipBeginDate).format('YYYY-MM-DD') + ' ~ ' + moment(nextYear.membershipEndDate).format('YYYY-MM-DD')
          nextYear.membershipBeginDate = getDateObjectByString(nextYear.membershipBeginDate)
          nextYear.membershipEndDate = getDateObjectByString(nextYear.membershipEndDate)
          nextYear.overallRegisterBeginDate = getDateObjectByString(nextYear.overallRegisterBeginDate)
          //
          const nextOrgRegisterBeginDate = getDateObjectByString(nextYear.orgRegisterBeginDate);
          const nextOrgRegisterEndDate = getDateObjectByString(nextYear.orgRegisterEndDate);
          const nextPlayerRegisterBeginDate = getDateObjectByString(nextYear.playerRegisterBeginDate);
          const nextPlayerRegisterEndDate = getDateObjectByString(nextYear.playerRegisterEndDate);
          this.nextOrgRange = [nextOrgRegisterBeginDate, nextOrgRegisterEndDate]
          this.nextPlayerRange = [nextPlayerRegisterBeginDate, nextPlayerRegisterEndDate]
          this.mapMemberType(this.nextRoleStatus, nextYear)
        }
      })
      getMemberShipTypeList().then(response => {
        const data = response.data
        if (!data.list) return
        const memberList = data.list
        this.memberList = memberList
        this.oldDataMode = data.oldDataMode;
      })
    },
    onSubmit() {
      const data = {
        year: this.currentYear.year
      }
      if (this.dialogVisible == true) {
        data.membershipBeginDate = moment(this.nextYear.membershipBeginDate).format('YYYY-MM-DD')
        data.membershipEndDate = moment(this.nextYear.membershipEndDate).format('YYYY-MM-DD')
        data.overallRegisterBeginDate = moment(this.nextYear.overallRegisterBeginDate).format('YYYY-MM-DD')
      }
      data.orgRegisterBeginDate = moment(this.currentOrgRange[0]).format('YYYY-MM-DD')
      data.orgRegisterEndDate = moment(this.currentOrgRange[1]).format('YYYY-MM-DD')
      data.playerRegisterBeginDate = moment(this.currentPlayerRange[0]).format('YYYY-MM-DD')
      data.playerRegisterEndDate = moment(this.currentPlayerRange[1]).format('YYYY-MM-DD')
      this.reverseMapMemberType(data, this.currentRoleStatus)
      updateMemberShipYear(data).then(response => {
        if (!response) return
        // this.$message({
        //   message: '保存成功',
        //   type: 'success',
        //   showClose: true,
        //   duration: 1000
        // })
      }).catch(err => {
        console.log(err)
      })
      this.onDialogSubmit()
    },
    onDialogSubmit() {
      const data = {
        year: this.nextYear.year
      }
//      if(!filters.CompareDate(this.nextYear.membershipBeginDate, this.nextYear.overallRegisterBeginDate)){
//        this.$message.error({ message: '开始时间需要小于结束时间' });
//        return ;
//      }
      data.membershipBeginDate = moment(this.nextYear.membershipBeginDate).format('YYYY-MM-DD')
      data.membershipEndDate = moment(this.nextYear.membershipEndDate).format('YYYY-MM-DD')
      data.overallRegisterBeginDate = moment(this.nextYear.overallRegisterBeginDate).format('YYYY-MM-DD')

      data.orgRegisterBeginDate = moment(this.nextOrgRange[0]).format('YYYY-MM-DD')
      data.orgRegisterEndDate = moment(this.nextOrgRange[1]).format('YYYY-MM-DD')
      data.playerRegisterBeginDate = moment(this.nextPlayerRange[0]).format('YYYY-MM-DD')
      data.playerRegisterEndDate = moment(this.nextPlayerRange[1]).format('YYYY-MM-DD')
      this.reverseMapMemberType(data, this.nextRoleStatus)
      updateMemberShipYear(data).then(response => {
        if (!response) return
        this.$message({
          message: '保存成功',
          type: 'success',
          showClose: true,
          duration: 1000
        })
        this.fetchData()
      }).catch(err => {
        console.log(err)
      })
    },
    mapMemberType(roleStatus, yearData) {
      if(yearData.orgRegisterOpen == 1) {
        roleStatus.push(1);
      }
      if(yearData.playerRegisterOpen == 1) {
        roleStatus.push(2);
      }
      if(yearData.coachRegisterOpen == 1) {
        roleStatus.push(3);
      }
      if(yearData.inRefereeRegisterOpen == 1) {
        roleStatus.push(4);
      }
      if(yearData.outRefereeRegisterOpen == 1) {
        roleStatus.push(5);
      }
    },
    reverseMapMemberType(data,roleStatus) {
      if (includes(roleStatus, 1)) {
        data.orgRegisterOpen = 1
      } else {
        data.orgRegisterOpen = 0
      }
      if (includes(roleStatus, 2)) {
        data.playerRegisterOpen = 1
      } else {
        data.playerRegisterOpen = 0
      }
      if (includes(roleStatus, 3)) {
        data.coachRegisterOpen = 1
      } else {
        data.coachRegisterOpen = 0
      }
      if (includes(roleStatus, 4)) {
        data.inRefereeRegisterOpen = 1
      } else {
        data.inRefereeRegisterOpen = 0
      }
      if (includes(roleStatus, 5)) {
        data.outRefereeRegisterOpen = 1
      } else {
        data.outRefereeRegisterOpen = 0
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.setting-container {
  margin: 30px 15px;
  .el-input {
    width: 400px;
  }
  .el-form-item {
    margin-bottom: 25px;
    .item {
      margin-bottom: 15px;
      &-checkbox {
        width: 120px;
      }
    }
    &.modal-item {
      .item {
        margin-left: 100px;
      }
    }
  }
  .content {
    padding-left: 10px;
    background-color: #F2F2F2;
    line-height: 32px;
    width: 400px;
    font-size: 14px;

    .text {
      padding-right: 20px;
    }

    .icon {
      font-size: 18px;
      cursor: pointer;
      position: relative;
      top: 2px;
      margin-left: 5px;
    }
  }

  .el-dialog {
    width: 540px;
    .el-form-item {
      margin-bottom: 25px;
      .item {
        margin-left: 100px;
        margin-bottom: 5px;
        &-checkbox {
          width: 120px;
        }
      }

      .el-input {
        width: 300px;
      }
    }

    .block {
      display: block;
    }
  }
}
</style>
